import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BotidService } from '@shared-angular/services/ragai/botid.service';
import { ChatbotConfig } from '@shared/index';
import { IframeCommunicationService } from '../services/iframe-communication/iframe-communication.service';
import { BotService } from './../services/bot.service';

export const botconfigResolver: ResolveFn<ChatbotConfig | null> = async (route) => {
  const botIdS: BotidService = inject(BotidService);
  const id = route.params['id'] as string;
  botIdS.setBotId(id);

  const botService: BotService = inject(BotService);
  const iFrameCom: IframeCommunicationService = inject(IframeCommunicationService);
  iFrameCom.botId = id;

  const botConfig = await botService.getBotConfigAsUser(id);
  return botConfig;
};
